/**
 * Convert Time from 24-hour to 12-hour
 * @param {string} time
 * @param {string} timezone
 */
export default (time, timezone) => {
    const newTime = time.split(':');
    const hour = newTime[0];
    const AmOrPm = hour >= 12 ? 'PM' : 'AM';
    const finalHour = hour % 12 || 12;

    return `${finalHour}:${newTime[1]} ${AmOrPm}`;
};
